// src/api/api.js
import axios from 'axios';
import { getToastAPI } from '../Components/ui/Toast';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://proyecto-flamingo-backend.onrender.com',
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true, // Enviar cookies HttpOnly en cada petición
});

// Si el body es FormData, quitar Content-Type para que el navegador lo ponga con el boundary correcto
api.interceptors.request.use(cfg => {
  if (cfg.data instanceof FormData) {
    delete cfg.headers['Content-Type'];
  }
  return cfg;
});

// Maneja errores 401 en rutas privadas
api.interceptors.response.use(
  response => response,
  error => {
    const cfg = error.config || {};
    const ignoredRoutes = [
      '/register',
      '/logeo',
      '/me',
      '/client',
      '/ticket',
      '/user',
      '/google_login',
      '/request_reset',
      '/reset_password',
      '/verify_email',
      '/enviar_verificacion',
      '/complete_profile'
    ];

    // Usamos endsWith para evitar falsos positivos
    const isIgnored = ignoredRoutes.some(route => cfg.url?.endsWith(route));

    if (error.response?.status === 401 && !isIgnored) {
      getToastAPI().show("Su sesión ha sido invalidada (quizá inició sesión en otro dispositivo).", { type: 'warning', duration: 4000 });
      setTimeout(() => {
        window.location.href = '/login';
      }, 2200);
    }

    return Promise.reject(error);
  }
);

export default api;
